import { useEffect } from "react";
import { useTheme } from "./__product__/theme/Theme.context";
import { ThemeEnum } from "./__product__/theme/Theme.model";
import OnlineMenuService, { StatisticIdentifiers } from "./api/service/OnlineMenuService";
import i18n from "./__product__/language/i18n";
import { useUserContext } from "./context/UserContext";

const AppHook = () => {
  const { setCurrentTheme } = useTheme();
  const { getOnlineMenu, getOnlineMenuCompanyInformation, statisticRequest, getOnlineMenuLanguages } =
    OnlineMenuService();
  const { currentOnlineMenu, setOrders, setUtag, setIsCartActive, orders } = useUserContext();

  useEffect(() => {
    const utag = new URLSearchParams(window.location.search).get("utag");
    const order = new URLSearchParams(window.location.search).get("order");
    if (utag) {
      setUtag(utag);
    }
    if (order === "true") {
      setIsCartActive(true);
    }
  }, []);

  useEffect(() => {
    const storageOrders = localStorage.getItem("orders");
    const initialOrders = storageOrders ? JSON.parse(storageOrders) : [];
    setOrders(initialOrders);
    if (currentOnlineMenu?.categoriesObj && storageOrders && storageOrders.length > 0) {
      initialOrders.forEach((order: any) => {
        if (order.type === "subfood") {
          const subfood = currentOnlineMenu?.categoriesObj
            ?.find((c) => c.id === order.categoryId)
            ?.foodsObj?.find((f) => f.id === order.foodId)
            ?.subFoodsObj?.find((s) => s.id === order.id);
          if (!subfood || subfood.orderPrice !== order.orderPrice) {
            setOrders([]);
          }
        } else {
          const food = currentOnlineMenu?.categoriesObj
            ?.find((c) => c.id === order.categoryId)
            ?.foodsObj?.find((f) => f.id === order.id);
          if (!food || food.orderPrice !== order.orderPrice) {
            setOrders([]);
          }
        }
      });
    }
  }, [currentOnlineMenu]);

  useEffect(() => {
    localStorage.setItem("orders", JSON.stringify(orders));
  }, [orders]);

  useEffect(() => {
    void getOnlineMenuLanguages().then((value) => {
      const lng = value.responseModel.length > 0 ? value.responseModel[0].language : "tr";
      void i18n.changeLanguage(lng).then(() => {
        void getOnlineMenu().then((res) => {
          void getOnlineMenuCompanyInformation().finally(() => {
            if (res.responseModel?.title) {
              void statisticRequest({
                url: window.location.pathname,
                objId: res.responseModel.id,
                onlineMenuId: res.responseModel.id,
                identifier: StatisticIdentifiers.ONLINE_MENU_PAGE_VIEW
              });
            }
          });
        });
      });
    });
  }, []);

  useEffect(() => {
    const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)");
    if (!localStorage.getItem("theme") && darkThemeMq.matches) {
      setCurrentTheme(ThemeEnum.LIGHT);
    } else {
      setCurrentTheme(ThemeEnum.LIGHT);
    }
  }, []);
};
export default AppHook;
